// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CommunityAutomationsRecordLoader_placeholder__1FFdx"};